document.addEventListener('DOMContentLoaded', function() {

const groups = document.querySelectorAll('.group-block');

groups.forEach(formGroup => {
  const radios = formGroup.querySelectorAll('input[type="radio"].js-radio');
  const newClassName = 'disp-block';

  radios.forEach(radio => {
  radio.addEventListener('change', () => {
    const prefixClass = Array.from(radio.classList).find(c => c.startsWith('choice-'));

    formGroup.querySelectorAll(`div.${newClassName}`).forEach(div => {
    div.classList.remove(newClassName);
    div.querySelectorAll('input, select').forEach(inp => inp.setAttribute('disabled', 'disabled'));
    });

    if (radio.checked && prefixClass) {
    formGroup.querySelectorAll(`div.${prefixClass}`).forEach(div => {
      div.classList.add(newClassName);
      div.querySelectorAll('input, select').forEach(inp => inp.removeAttribute('disabled'));
    });
    }

    //.log('in form-group:', formGroup, 'prefixClass:', prefixClass);
  });
  });

  const boxes = formGroup.querySelectorAll('input[type="checkbox"].js-radio');

  boxes.forEach(box => {
  box.addEventListener('change', () => {
    const prefixClass = Array.from(box.classList)
    .find(c => c.startsWith('choice-'));
    if (!prefixClass) return;

    formGroup.querySelectorAll(`div.${prefixClass}`).forEach(div => {

      div.classList.toggle(newClassName, box.checked);
    });

  });
  });

});
});

const submitButton = document.querySelector('.sf-send-btn');
const scrollTarget = document.querySelector('.contact');

function onSubmitClick(event) {
  if (typeof scrollTarget !== 'undefined' && scrollTarget) {
  const headerHeight = document.querySelector('header').offsetHeight;
  const elementPosition = scrollTarget.getBoundingClientRect().top + window.pageYOffset;
  const offsetPosition = elementPosition - headerHeight;

  scrollTarget.scrollIntoView({
    top: offsetPosition,
    behavior: 'smooth'
  });

  const target = document.querySelector('.formrun-system-show');
  if (target) {
    const refDiv = document.getElementById('reference');
    if (refDiv) {
      refDiv.style.display = '';
    }
    }
  // console.log(target);
  }
}
submitButton.addEventListener('click', onSubmitClick);


function verifyCallback() {
  document.querySelector('button[type=submit]').removeAttribute("disabled");
}
function expiredCallback() {
  document.querySelector('button[type=submit]').setAttribute("disabled", true);
}
